import { Grid } from '@mui/material';
import TextField from 'components/text-field';
import React, { FC } from 'react';
import { Controller, useForm } from 'react-hook-form';
import ContainerModal from './modal-container';
import graphql from 'services/querys';
import { useMutation } from 'react-query';
import { NewPhoneType } from 'types/new-user';
import { useTranslation } from 'react-i18next';

type DialogPhoneProps = {
  open: boolean;
  onClose: () => void;
  partyId: string;
  onSuccess: (phones: NewPhoneType[]) => void;
};

type createPhoneForm = {
  number: string;
  kind: string;
};

const CreatePhone: FC<DialogPhoneProps> = ({ open, onClose, partyId, onSuccess }) => {
  const { t } = useTranslation();
  const { mutate: createPhone, ...responseCreatePhone } = useMutation(graphql.createPhone, {
    onSuccess: (data) => {
      responseCreatePhone.reset();
      onSuccess(data.createPhone?.phones || []);
      onClose();
    },
  });
  const methods = useForm<createPhoneForm>({
    defaultValues: {
      number: '',
      kind: '',
    },
  });

  const { control, handleSubmit, formState } = methods;
  const isSaving = responseCreatePhone.isLoading;

  return (
    <ContainerModal
      open={open}
      onClose={onClose}
      onCancel={onClose}
      onSave={() => {
        handleSubmit((data) => {
          createPhone({
            partyId,
            kind: data.kind,
            data: {
              number: data.number,
            } as NewPhoneType,
          });
        })();
      }}
      disableSavebutton={!formState.isValid}
      loadingSaveButton={isSaving}
      modalTitle={t('contact:addPhoneModalTitle')}
    >
      <Grid container direction="column" spacing={3}>
        <Grid item>
          <Controller
            control={control}
            name="number"
            rules={{ required: true }}
            render={({ field: { ref, ...field } }) => <TextField {...field} inputRef={ref} disabled={isSaving} label={t('contact:numberLabel')} />}
          />
        </Grid>
        <Grid item>
          <Controller
            control={control}
            name="kind"
            rules={{ required: true }}
            render={({ field: { ref, ...field } }) => <TextField {...field} inputRef={ref} disabled={isSaving} label={t('contact:kindLabel')} />}
          />
        </Grid>
      </Grid>
    </ContainerModal>
  );
};

export default CreatePhone;
